<template>
    <div v-if="canBeRecurring">
        <div :class="[$style.formItem]">
            <h4>Set Invoice as Recurring</h4>
        </div>
        <UiSelect
                name="is_recurring"
                :value="'0'"
                maxHeight="240px"
                :options="is_recurring_options"
                :hasReversible="true"
                tabindex="3"
                @input="changeRecurring($event)"
        />
        <div
                v-if="recurring_period_visible"
        >
            <h5>Recurring Period</h5>
            <UiSelect
                    name="recurring_period"
                    maxHeight="240px"
                    :hasError="$isFieldInvalid('recurring_period')"
                    :errorText="$t('Recurring.recurringPeriodInvalid')"
                    :options="recurring_options"
                    :hasReversible="true"
                    tabindex="4"
                    @input="changeRecurringPeriod($event)"
            />
        </div>

    </div>
</template>

<script>

import UiTextField from "@/components/UiTextField.vue";
import UiSelect from "@/components/UiSelect.vue";

export default {
  name: 'Recurring',
  components: { UiTextField },
  props: {
    canBeRecurring: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      recurring_period: '0',
      recurring_period_visible: false,
      is_recurring_options: [
        { value: '0', label: 'No' },
        { value: '1', label: 'Yes' },
      ],
      recurring_options: [
        { value: '1', label: 'Daily' },
        { value: '2', label: 'Weekly' },
        { value: '3', label: 'Monthly' },
        { value: '4', label: 'Yearly' },]
    };
  },
  created() {
  },
  validations() {
    return {
      recurring_period: {
        is_selected() {
          return !this.recurring_period_visible || this.recurring_period !== '0';
        },
      }
    }
  },
  methods: {
    changeRecurring(value) {
      this.recurring_period_visible = value === '1';
      this.recurring_period = '0';
    },
    changeRecurringPeriod(value) {
      this.recurring_period = value;
      this.$emit('change', value);
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
};
</script>

<style module lang="scss">
.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}
</style>
